export default "__VITE_ASSET__BF2wErD$__"